import React, { Component } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import WaitableCard from '../../components/WaitableCard';
import ReactTable from "react-table";
import PropTypes from "prop-types";
import ClientManagementContainer  from '../../containers/Clients/ClientManagementContainer';
import ClientInvitationsContainer from '../../containers/Clients/ClientInvitationsContainer';

//import InviteClientModal from './InviteClientModal';
import EmptyData from '../../components/EmptyData';
import moment from 'moment';
import { numericFilter, textFilter, NumericFilter } from '../../lib/tableFilters';
import classnames from 'classnames';
import ClientRateRequestContainer from '../../containers/Clients/ClientRateRequestsContainer'
import ClientAccessRequestContainer from '../../containers/Clients/ClientAccessRequestContainer'
import {
  Badge,
  Button,
  Row,
  Col,
  Card,
  CardHeader,
  TabContent,
  Nav,
  NavItem,
  NavLink,
  TabPane
} from 'reactstrap';


const columns = [
  {
    Header: "Name",
    accessor: "name",
    filterMethod: textFilter
  },
  {
    Header: "First Name",
    id: "firstName",
    accessor: d => d.primaryContact.firstName,
    filterMethod: textFilter
  },

  {
    Header: "Last Name",
    id: "lastName",
    accessor: d => d.primaryContact.lastName,
    filterMethod: textFilter
  },
  {
    Header: "Email",
    id: "email",
    accessor: d => d.primaryContact.email,
    filterMethod: textFilter
  }

]


export default class Clients extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //inviteClientModelIsOpen: false,
      activeTab: '1',
      activeInviteTab: '1'
    };

    //this.toggleInviteClient = this.toggleInviteClient.bind(this);
    //this.onInviteClient = this.onInviteClient.bind(this);
    this.toggle = this.toggle.bind(this);

  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }


  toggleInviteTab(tab) {
    if (this.state.activeInviteTab !== tab) {
      this.setState({
        activeInviteTab: tab
      });
    }
  }



  render() {
    let { clients/*, invitations */} = this.props;
    let { inviteClientModelIsOpen } = this.state;
    let data = clients.get('data') || [];
    //let invitationData = invitations.get('data') || [];
    return <div className="animated fadeIn">
      <Row>
        <Col xs="12" lg="12">
          <Card>
            <CardHeader>
              <i className="fa fa-sitemap"></i> Active Clients
            </CardHeader>
            <WaitableCard entity={clients}>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: this.state.activeTab === '1' })}
                    onClick={() => { this.toggle('1'); }}>
                    Clients
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: this.state.activeTab === '2' })}
                    onClick={() => { this.toggle('2'); }}>
                    Rate Request Log
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId="1">
                  <ClientManagementContainer/>
                </TabPane>
                <TabPane tabId="2">
                  <ClientRateRequestContainer />
                </TabPane>
              </TabContent>
            </WaitableCard>
          </Card>
        </Col>
        <Col xs="12" lg="12">
          <Card>
            <CardHeader>
              <i className="fa fa-sitemap"></i> Invitation Management
            </CardHeader>

              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: this.state.activeInviteTab === '1' })}
                    onClick={() => { this.toggleInviteTab('1'); }}>
                    Outgoing Invitations
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: this.state.activeInviteTab === '2' })}
                    onClick={() => { this.toggleInviteTab('2'); }}>
                    Client Access Request
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={this.state.activeInviteTab}>
                <TabPane tabId="1">

                  <ClientInvitationsContainer />

                </TabPane>
                <TabPane tabId="2">
                  <ClientAccessRequestContainer />
                </TabPane>
              </TabContent>

          </Card>
        </Col>
      </Row>
    </div>;
  }
}


Clients.propType = {
  invitations: PropTypes.array,
  clients: PropTypes.array
};


// WEBPACK FOOTER //
// ./src/views/Clients/Clients.js